import { Table, Tag, Typography, Space, theme } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { format, isValid } from "date-fns";
import { StatusBadge } from "./StatusBadge";

const { Text } = Typography;

export function AuditLogTable({
  logs,
  onRowClick,
  pagination,
  currentPage,
  onPageChange,
  loading,
}) {
  const { token } = theme.useToken();

  const columns = [
    {
      title: "Session ID",
      dataIndex: "correlationId",
      key: "correlationId",
      render: (id, record) => (
        <Space direction="vertical" size={0}>
          <Text code style={{ fontSize: 12 }}>
            {id?.slice(0, 12)}...
          </Text>
          {record.logName && (
            <Tag style={{ margin: 0, marginTop: 4 }}>{record.logName}</Tag>
          )}
        </Space>
      ),
    },
    {
      title: "Module",
      dataIndex: "module",
      key: "module",
      render: (module) => <Tag color="blue">{module}</Tag>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <StatusBadge status={status} />,
    },
    {
      title: "Last Step",
      dataIndex: "lastStep",
      key: "lastStep",
      ellipsis: true,
      render: (step) => (
        <Text ellipsis style={{ maxWidth: 200 }}>
          {step}
        </Text>
      ),
    },
    {
      title: "Started",
      dataIndex: "startedAt",
      key: "startedAt",
      render: (date) => (
        <Text type="secondary" style={{ fontSize: 13 }}>
          {format(new Date(date), "MMM d, HH:mm")}
        </Text>
      ),
    },
    {
      title: "",
      key: "action",
      width: 40,
      render: () => (
        <RightOutlined style={{ color: token.colorTextSecondary }} />
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      className="audit-log-table"
      dataSource={logs}
      rowKey="id"
      loading={loading}
      onRow={(record) => ({
        onClick: () => onRowClick(record),
        style: { cursor: "pointer" },
      })}
      pagination={{
        current: currentPage,
        pageSize: pagination?.perPage || 20,
        total: pagination?.total,
        showSizeChanger: false,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} items`,
        onChange: onPageChange,
      }}
      locale={{
        emptyText: "No trace logs found matching your criteria",
      }}
    />
  );
}
